import React from "react";

const storeLinks = [
  { name: 'Wildberries', url: 'https://www.wildberries.ru/catalog/0/search.aspx?search=morena%20cosmetics' },
  { name: 'OZON', url: 'https://www.ozon.ru/seller/morena-cosmetics-1161439/krasota-i-zdorove-6500/?__rr=1&miniapp=seller_1161439' },
  { name: 'Золотое Яблоко', url: 'https://goldapple.ru/brands/morena-cosmetics' },
  { name: 'Лэтуаль', url: 'https://www.letu.ru/brand/morena-cosmetics' }
];

export const Header = () => {

  const openStore = (url, event) => {
  event.preventDefault();
  event.currentTarget.blur(); // Remove focus (important for mobile)
  setTimeout(() => {
    window.open(url, '_blank', 'noopener,noreferrer');
  }, 100); // 100ms gives enough time on slower devices
};

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="links">
              {storeLinks.map((store, index) => (
                <button 
                  key={index}
                  className="store-link" 
                  onClick={(e) => openStore(store.url, e)}
                >
                  {store.name}
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
